
export function jsonToCsv(jsonArray: any[]) {

  if (!jsonArray || !jsonArray.length) return "";

  const headers = Object.keys(jsonArray[0]);
  const csvRows = [];
  csvRows.push(headers.join(","));

  for (const obj of jsonArray) {
    const values = headers.map(header => {
      const escapedValue = ("" + obj[header]).replace(/"/g, `""`); // Escape double quotes
      return `"${escapedValue}"`; // Wrap each value in double quotes
    });
    csvRows.push(values.join(","));
  }

  return csvRows.join("\n");
}


export function downloadFile(text: string, filename: string, type: string = "text/plain") {
  const element = document.createElement("a");
  element.setAttribute("href", `data:${type};charset=utf-8,` + encodeURIComponent(text));
  element.setAttribute("download", filename);
  element.style.display = "none";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}
